<div class="bottom-nav">
  <div class="bottom-nav-container">
    <button class="btn nav-btn d-block p-1 px-2" routerLink="/viettel/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
        <i class="ri-home-3-line nav-icon"></i>
        <div class="font-size-12 nav-label">
          Trang chủ
        </div>
    </button>
    <div class="bottom-nav-center" routerLink="/viettel/create-qr">
      <img src="/assets/images/qr-button-container.png" class="qr-btn-img" alt="QR" />
    </div>
    <button class="btn nav-btn d-block p-1 px-2" routerLink="/viettel/menu" routerLinkActive="active">
      <i class="ri-settings-3-line nav-icon"></i>
      <div class="font-size-12 nav-label">
        Quản lý
      </div>
    </button>
  </div>
</div>
